import { atom, map } from 'nanostores';
import type { AssistantState, ChatMessage, PageContext, QuickChip, SelectInputPayload } from '../types/assistant';

const STORAGE_KEY = 'didi_assistant_state';

function loadPersistedState(): Partial<AssistantState> {
  try {
    const saved = sessionStorage.getItem(STORAGE_KEY);
    return saved ? JSON.parse(saved) : {};
  } catch {
    return {};
  }
}

const persisted = loadPersistedState();

export const assistantWidget = map<AssistantState>({
  activePanel: (persisted.activePanel as AssistantState['activePanel']) || 'chat',
  activeConversationId: persisted.activeConversationId || null,
  hasUnread: false,
  summaryDismissed: persisted.summaryDismissed || false,
});

export const assistantPageContext = atom<PageContext>({});
export const assistantMessages = atom<ChatMessage[]>([]);
export const assistantStreaming = atom<boolean>(false);
export const assistantStreamBuffer = atom<string>('');
export const assistantPendingIntent = atom<string | null>(null);
export const assistantSuggestions = atom<QuickChip[]>([]);
export const assistantSelectInput = atom<SelectInputPayload | null>(null);

// Persist key state to sessionStorage on changes
assistantWidget.subscribe((state) => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
      activePanel: state.activePanel,
      activeConversationId: state.activeConversationId,
      summaryDismissed: state.summaryDismissed,
    }));
  } catch {
    // sessionStorage unavailable
  }
});
